// ─── La regla de una contraseña nueva, UNA sola vez ─────────────────────────
// La usan la pantalla de activación (para habilitar el botón y pintar la
// barra) y el servidor (completeInviteActivation, que la valida antes de
// fijarla). Antes vivía solo en la página: el servidor confiaba en el
// navegador. Es la MISMA regla que tenía la web, sin endurecerla: al menos 6
// caracteres (el mínimo de Firebase Auth) y un puntaje de 2 o más.
export const PASSWORD_MIN_LENGTH = 6;
/** Puntaje de 0 a 5: largo ≥ 8, largo ≥ 12, una mayúscula, un dígito, un
 *  símbolo. */
export function passwordScore(pw) {
    let score = 0;
    if (pw.length >= 8)
        score++;
    if (pw.length >= 12)
        score++;
    if (/[A-Z]/.test(pw))
        score++;
    if (/[0-9]/.test(pw))
        score++;
    if (/[^A-Za-z0-9]/.test(pw))
        score++;
    return score;
}
/** ¿Se acepta como contraseña nueva? */
export function isAcceptableNewPassword(pw) {
    return typeof pw === 'string' && pw.length >= PASSWORD_MIN_LENGTH && passwordScore(pw) >= 2;
}
//# sourceMappingURL=password-policy.js.map